import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import { Modal, Input, Spin, Switch } from "antd";
import { isEmpty } from "utils/GlobalFunctions";
import "pages/ShopProductListPage/AddProductDialog/ShopDialog.css";

function AddCategoryDialog(props) {
  const { show, proceed, record, title } = props;

  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState([]);
  const [isBusy] = useState(false);

  useEffect(() => {
    if (record !== undefined) {
      setData({ ...record });
    } else {
      setData({ status: "0" });
    }
  }, [record?.id]);

  const onViewMode = (checked) => {
    setData({ ...data, status: checked === true ? "1" : "0" });
  };

  const onChangeValue = (field, value) => {
    setData({ ...data, [field]: value });
    setErrorField(errorField.filter((x) => x !== field));
  };

  const validateFields = () => {
    var errorList = Array();
    errorList = isEmpty(data, "name", errorList);
    setErrorField([...errorList]);
    return errorList.length == 0;
  };

  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => proceed(null)}
      closable={true}
      maskClosable={false}
      title={title}
      className="shop-modal"
      width={480}
      okText="Save"
      onOk={() => {
        if (validateFields() === false) return;
        proceed({ ...data });
      }}
    >
      <Spin spinning={isBusy}>
        <div>
          <div className="shop-switch-row">
            <label className="shop-field-label" style={{ marginBottom: 0 }}>
              Publish
            </label>
            <Switch
              checkedChildren="Show"
              unCheckedChildren="Hide"
              onChange={onViewMode}
              checked={data["status"] === "1" ? true : false}
            />
          </div>
          <div className="shop-field" style={{ marginBottom: 0 }}>
            <label className="shop-field-label">
              Name<span className="req">*</span>
            </label>
            <Input
              placeholder="Enter category name..."
              value={data["name"] || ""}
              status={errorField.includes("name") ? "error" : ""}
              onChange={(e) => onChangeValue("name", e.target.value)}
            />
          </div>
        </div>
      </Spin>
    </Modal>
  );
}

export default confirmable(AddCategoryDialog);
